import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { wsRemove, wsGet, wsPost } from 'services/WService';
import ReactTable from 'components/ReactTable/ReactTable';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Add, Delete } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { useParams } from 'react-router-dom';
import { useModal } from 'hooks/useModal';
import AddUserModal from './AddUserModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Usuario', accessor: 'name', width: 200 },
  { Header: 'Login', accessor: 'email', width: 200 },
  { Header: 'Email', accessor: 'notification_email' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function NotificationDetail() {
  const { id } = useParams();
  const [notification, setNotification] = useState({});
  const [users, setUsers] = useState([]);
  const [addUserModel, setAddUserModel] = useModal();
  const [notify, showNotify] = useToasty();
  const [processing, setProcessing] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);  

  async function getNotification() {
    setDataLoading(true);
    let res = await wsGet('mail/notification', id);
    setDataLoading(false);
    if (!res.success) {
      return;
    }
    let { users, ...notification } = res.data;
    setNotification(notification);
    setUsers(users);
  }

  async function removeUser(userId) {
    setDataLoading(true);
    setProcessing(true);
    let res = await wsRemove(`mail/notification/${id}/user`, userId);
    setDataLoading(false);
    if (res.success) {
      await getNotification();
      setProcessing(false);
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
      setProcessing(false);
    }
  }

  async function addUser(data) {
    setDataLoading(true);
    let res = await wsPost(`mail/notification/${id}/user`, data);
    setDataLoading(false);
    if (res.success) {
      getNotification();
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    getNotification();
  }, []);
  const titleText = `Usuarios de notificación: ${notification.name || ''}`
  return (
    <CardContainer
      title={<>{titleText} {dataLoading && <LoadingSpinner />}</>}
      icon={<Add />}
      onClick={() => {
        setAddUserModel({ ...notification, open: true });
      }}
    >
      <Toasty action={notify} />
      <AddUserModal
        model={addUserModel}
        setOpen={setAddUserModel}
        onSave={addUser}
        addedUsers={users}
      />
      <GridContainer>
        <GridItem xs={12}>Descripción: {notification.description}</GridItem>
      </GridContainer>
      <ReactTable
        columns={columns}
        data={users.map((user, index) => {
          return {
            ...user,
            num: (
              <div className="actions-right">
                {index + 1}
                <Button
                  justIcon
                  round
                  simple
                  color="danger"
                  className="like"
                  disabled={processing}
                  onClick={() => removeUser(user.id)}
                >
                  <Delete />
                </Button>
              </div>
            ),
          };
        })}
      />
    </CardContainer>
  );
}

export default NotificationDetail;
